import React from "react";
import styles from "./LinkList.module.less";

export interface Props {
    links: {
        text: string;
        url: string;
    }[];
}

export default function Intro(props: Props) {
    return (
        <ul className={styles.LinkList}>
            {props.links.map((link, index) => (
                <li className={styles["LinkList-li"]} key={index}><a href={link.url} className={styles["LinkList-a"]} target="_blank" rel="noopener noreferrer">{link.text}</a></li>
            ))}
        </ul>
    );
}
